<template>
  <Portal>
    <div
      ref="container"
      :class="classes.root"
      :data-p="dataP"
      :style="styles.root"
    >
      <transition-group
        name="ui-toast-message"
        tag="div"
        @enter="onEnter"
        @leave="onLeave"
      >
        <ToastMessage
          v-for="msg of messages"
          :key="msg.id"
          :closeIcon="closeIcon"
          :message="msg"
          :messageIcon="messageIcon"
          :templates="$slots"
          :unstyled="unstyled"
          @close="remove($event)"
        />
      </transition-group>
    </div>
  </Portal>
</template>

<script>
import { cn } from '../../utils/classnames/cn.js';
//import { setAttribute } from '../../utils/dom/index.js';
import { isEmpty } from '../../utils/object/index.js';
import { ZIndex } from '../../utils/zindex/zindex.js';
import Portal from '../portal/portal.vue';
import ToastEventBus from '@wholebodyapp/ui-components/src/toast-service/toast-event-bus.js';
import ToastMessage from './toast-message.vue';
import { toastProps } from './toast-props.js';
var messageIdx = 0;

const messageDefaults = {
  closeIcon: false,
  detail: null,
  // group: 'tr',
  hed: null,
  life: 7500,
  messageIcon: true,
  mini: false,
  variant: 'info-soft',
};

export default {
  name: 'Toast',
  components: {
    ToastMessage: ToastMessage,
    Portal: Portal
  },
  provide () {
    return {
      $pcToast: this,
      $parentInstance: this
    };
  },
  inheritAttrs: false,
  props: toastProps,
  emits: ['close', 'life-end'],
  data() {
    return {
      messages: []
    };
  },
  computed: {
    classes () {
      return {
        root: [ `ui-toast ui-component ui-toast-${this.position}` ],
      };
    },
    dataP() {
      return cn({
        [this.position]: this.position
      });
    },
    styles () {
      return {
        root: {
          position: 'fixed',
          top: this.position === 'top-right' || this.position === 'top-left' || this.position === 'top-center' ? '20px' : this.position === 'center' ? '50%' : null,
          right: (this.position === 'top-right' || this.position === 'bottom-right') && '20px',
          bottom: (this.position === 'bottom-left' || this.position === 'bottom-right' || this.position === 'bottom-center') && '20px',
          left: this.position === 'top-left' || this.position === 'bottom-left' ? '20px' : this.position === 'center' || this.position === 'top-center' || this.position === 'bottom-center' ? '50%' : null,
        }
      };
    },
  },
  styleElement: null,
  mounted() {
    ToastEventBus.on('add', this.onAdd);
    ToastEventBus.on('remove', this.onRemove);
    ToastEventBus.on('remove-group', this.onRemoveGroup);
    ToastEventBus.on('remove-all-groups', this.onRemoveAllGroups);

    if (this.breakpoints) {
      this.createStyle();
    }
  },
  beforeUnmount() {
    this.destroyStyle();
    if (this.$refs.container && this.autoZIndex) {
      ZIndex.clear(this.$refs.container);
    }

    ToastEventBus.off('add', this.onAdd);
    ToastEventBus.off('remove', this.onRemove);
    ToastEventBus.off('remove-group', this.onRemoveGroup);
    ToastEventBus.off('remove-all-groups', this.onRemoveAllGroups);
  },
  methods: {
    add(message) {
      if (message.id == null)
        message.id = messageIdx++;
      this.messages = [...this.messages, message];
    },
    remove(params) {
      const index = this.messages.findIndex((m) => m.id === params.message.id);

      if (index !== -1) {
        this.messages.splice(index, 1);
        this.$emit(params.type, { message: params.message });
      }
    },
    onAdd(message) {
      if (this.group == message.group) {
        this.add({...messageDefaults, ...message});
      }
    },
    onRemove(message) {
      this.remove({ message, type: 'close' });
    },
    onRemoveGroup(group) {
      if (this.group === group) {
        this.messages = [];
      }
    },
    onRemoveAllGroups() {
      this.messages.forEach((message) => this.$emit('close', { message }));
      this.messages = [];
    },
    onEnter() {
      if (this.autoZIndex) {
        // TODO: think this.$ui should be definde, but doesn't seem to be?
        //ZIndex.set('modal', this.$refs.container, this.baseZIndex || this.$ui.zIndex.modal);
        ZIndex.set('modal', this.$refs.container, this.baseZIndex || 300);
      }
    },
    onLeave() {
      if (this.$refs.container && this.autoZIndex && isEmpty(this.messages)) {
        setTimeout(() => {
          ZIndex.clear(this.$refs.container);
        }, 200);
      }
    },
    createStyle() {
      if (!this.styleElement && !this.isUnstyled) {
        this.styleElement = document.createElement('style');
        this.styleElement.type = 'text/css';
        // setAttribute(this.styleElement, 'nonce', this.$primevue?.config?.csp?.nonce);
        document.head.appendChild(this.styleElement);

        let innerHTML = '';

        for (let breakpoint in this.breakpoints) {
          let breakpointStyle = '';

          for (let styleProp in this.breakpoints[breakpoint]) {
            breakpointStyle += styleProp + ':' + this.breakpoints[breakpoint][styleProp] + '!important;';
          }

          innerHTML += `
            @media screen and (max-width: ${breakpoint}) {
              .ui-toast[${this.$attrSelector}] {
                  ${breakpointStyle}
              }
            }
          `;
        }

        this.styleElement.innerHTML = innerHTML;
      }
    },
    destroyStyle() {
      if (this.styleElement) {
        document.head.removeChild(this.styleElement);
        this.styleElement = null;
      }
    }
  },


};
</script>
